import React, { useState } from 'react';
import Header from '../../../../component/Header';
import Select from 'react-select';
import { useForm, Controller } from "react-hook-form";
import axios from 'axios';
import { useHistory } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../../../../component/Breadcrumb';
import Layout from '../../../Layout';

const customStyles = {
    option: (provided, state) => ({
      ...provided
    }),
    control: () => ({
      display: 'flex',
      background: '#fff',
      border: '1px solid rgb(209, 213, 219)',
      padding: '2px .1rem'
    }),
    menu: () => ({
      padding: '0',
      background: '#fff',
      position: 'absolute',
      top: '100%',
      boxShadow: "0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%)",
      width: '100%',
      zIndex: '500'
    }),
}
//variable for temporary division data
let divisionResponse = [];

//options data for role select
const roleOptions = [];

//variable restructured division options
const options = [];

const CreateUser = () => {

    const history = useHistory();
    const success = () => toast.success("User saved!", {
        position: toast.POSITION.TOP_CENTER,
        onClose: props => history.push("/admin/user")
    });

    const unauthorized = () => toast.warning("You aren't authorized to do this", {
        position: toast.POSITION.TOP_CENTER,
    });

    //state for selected role
    var [selectedrole, setSelectedrole] = useState();

    //state for error catching from server
    var [err, setErr] = useState({});

    //state if form has error form server
    var [hasError, setHasError] = useState(false);


    //fetching role
    const fetchRole = React.useCallback(() => {
        axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_API}/api/role`,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            })
            .then(response => {
                if (response.data.code !== 401) {
                    let roleRaw = response.data.data
                    if (roleRaw.length > 0) {
                        //restructure response for division select
                        roleRaw.forEach(role => {
                        let roleDivide = {}
                        roleDivide.value = role.id
                        roleDivide.label = role.name
                        roleOptions.push(roleDivide)
                        })
                    }
                }
            })
    }, [])
    
    //fetching division
    const fetchDivision = React.useCallback(() => {
        axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_API}/api/division/all`,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            })
            .then(response => {
                if (response.data.code !== 401) {
                    divisionResponse = response.data.data
                    if (divisionResponse.length > 0) {
                        divisionResponse.forEach(division => {
                        let divisionDivide = {}
                        divisionDivide.value = division.id
                        divisionDivide.label = division.name
                        options.push(divisionDivide)
                        })
                    }
                }
            });
    }, []);

    //fetching division on page load
    React.useEffect(() => {
        fetchRole()
    }, [fetchRole])

    //fetching division on page load
    React.useEffect(() => {
        fetchDivision()
    }, [fetchDivision])

    const { handleSubmit, register, formState: { errors }, control, setValue, reset } = useForm();

    const onSubmit = (data) => {
            axios({
                method: "post",
                url: `${process.env.REACT_APP_BASE_API}/api/admin/user/store`,
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
            })
            .then(function (response){
                if (response.data.code !== 401) {
                    success();
                    reset();
                }else{
                    unauthorized();
                }
                
            })
            .catch(error => {
                if (error.response) {
                    setErr(error.response.data.errors);
                    setHasError(true);
                }
              });
    };

    //handling change for division select
    const handleChange = (change) => {
        setValue("division_id", change.value);
    };


    //handling change for role select
    const handleChangeRole = (change) =>{
        setSelectedrole(change)
        setValue("role", change.label);
    };

    //function to render error from server
    function ErrorComponent() {
        return Object.keys(err).map((visit, index) => 
            <ul className="list-none">
                <li className="p-3 mb-4 text-white bg-red-500 radius-sm" key={index}>{err[visit]}</li>
            </ul>
        )
    };

    const breadcrumb = [
        { pageTitle: 'Home', pageHref: '/admin' },
        { pageTitle: 'User', pageHref: '/admin/user' },
        { pageTitle: 'Create', pageHref: '' },
    ]

    return (
        <Layout>
            <ToastContainer />
            <div className="min-h-screen p-12">
                <Breadcrumb data={breadcrumb} />
                <h1 className="mb-5 text-xl font-bold">
                    Admin User Create
                </h1>
                <div className="px-4 py-6 bg-gray-200 shadow-lg card">
                    {hasError && <ErrorComponent></ErrorComponent>}
                    <form onSubmit={handleSubmit(onSubmit)} className="w-full md:w-1/5">
                        <div className="mb-6">
                            <label for="email" className="block mb-2 text-sm font-semibold text-blue-900">Email</label>
                            <input 
                                type="text" 
                                name="email" 
                                id="email" 
                                {...register("email", { 
                                    required: 'Email is required', 
                                    pattern: { 
                                        value: /([a-zA-Z0-9]+)([.{1}])?([a-zA-Z0-9]+)@aqi([.])co([.])id/g, 
                                        message: "Please use AQI email."} 
                                })} 
                                className="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                            {errors?.email && <div>{errors.email.message}</div>}
                        </div>
                        <div className="mb-6">
                            <label for="name" className="block mb-2 text-sm font-semibold text-blue-900">Name</label>
                            <input 
                                type="text" 
                                name="name" 
                                id="name" 
                                {...register("name", { 
                                    required: 'Name is required', 
                                })}  
                                className="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" />
                            {errors?.name && <div>{errors.name.message}</div>}
                        </div>
                        <div className="mb-6">
                            <label for="division" className="block mb-2 text-sm font-semibold text-blue-900">Role</label>
                            <Controller
                                control={control}
                                name="division_id"
                                options={options} 
                                render={({ onChange, value }) => (
                                    <Select 
                                        className="w-full" 
                                        styles={customStyles} 
                                        options={options} {...register("division_id", { required: 'Please choose role' })} 
                                        value={options.find(c => c.value === value)} 
                                        onChange={handleChange} 
                                        />
                                )}
                            />
                            {errors?.division_id && <div>{errors.division_id.message}</div>}
                        </div>
                        <div className="mb-6">
                            <label for="role" className="block mb-2 text-sm font-semibold text-blue-900">Access Permission Type</label>
                            <Controller
                                control={control}
                                name="role"
                                options={roleOptions} 
                                render={({ onChange, value }) => (
                                    <Select 
                                        className="w-full" 
                                        isSearchable={false}
                                        styles={customStyles} 
                                        options={roleOptions} {...register("role", { required: 'Please choose Access Permission Type' })} 
                                        onChange={handleChangeRole}
                                        value={selectedrole}
                                        />
                                )}
                            />
                            {errors?.role && <div>{errors.role.message}</div>}
                        </div>
                        <div className="flex justify-between">
                            <a href="/admin/user" className="w-24 px-4 py-2 text-sm font-semibold tracking-wider text-center text-white bg-gray-400 rounded hover:bg-gray-700">Cancel</a>
                            <button type="submit" className="w-24 px-4 py-2 text-sm font-semibold tracking-wider text-white bg-green-600 rounded hover:bg-green-700">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    )
}

export default CreateUser